import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  FormGroup,
  Grid,
  Typography,
} from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useForm } from 'react-hook-form'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { wizardAPI } from 'utils/wizardAPI'
import { Input } from './Input'
import { setUserWizardDone } from 'reduxLib/slices/userSlice'

export default function SelectionMesObjective() {
  let w_selectionr = localStorage.getItem('w-selectionr')
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const [open, setOpen] = useState(false)
  useEffect(() => {
    if (w_selectionr) {
      setOpen(true)
    } else {
      navigate('/')
    }
  }, [])
  return <>{open && <DefinissezObjective setOpen={setOpen} />}</>
}

function DefinissezObjective({ setOpen }) {
  const navigate = useNavigate()
  const dispatch = useDispatch()
  let w_selectionr = localStorage.getItem('w-selectionr')
  const [userMesObj, setUserMesObj] = useState([])
  const [selectedCheckboxes, setSelectedCheckboxes] = useState([])
  const [loadError, setLoadError] = useState(false)
  const { handleSubmit, control, reset, setValue } = useForm({})

  useEffect(() => {
    fetchUserMesObj()
  }, [])

  const handleClose = () => {
    setOpen(false)
    reset()
  }

  const onSubmit = async (data) => {
    try {
      const selected = selectedCheckboxes.filter(Boolean)
      if (selected.length === 0) {
        alert('Sélectionnez au moins un objectif avant de sauvegarder.')
        return
      }
      await wizardAPI.updateUserObjectives({ selected })
      if (w_selectionr) {
        localStorage.setItem('wsr_done', true)
        navigate('/')
      }
      handleClose()
    } catch (error) {
      console.error('Error updating user objectives:', error)
      const msg = error?.response?.data?.error || error?.message || 'Erreur lors de la sauvegarde des objectifs. Veuillez réessayer.'
      alert(typeof msg === 'string' ? msg : 'Erreur lors de la sauvegarde. Veuillez réessayer.')
    }
  }
  
  const handelOnChange = (e) => {
    const raw = e.target?.name ?? ''
    const ideaId = typeof raw === 'string' ? raw.replace(/^idea-/, '') : ''
    if (!ideaId) return
    let updatedSelectedCheckboxes

    if (selectedCheckboxes.includes(ideaId)) {
      updatedSelectedCheckboxes = selectedCheckboxes.filter((id) => id !== ideaId)
    } else {
      if (selectedCheckboxes.length >= 5) {
        alert('Maximum 5 objectifs peuvent être sélectionnés')
        return
      }
      updatedSelectedCheckboxes = [...selectedCheckboxes, ideaId]
    }

    setSelectedCheckboxes(updatedSelectedCheckboxes)
  }
  
  const fetchUserMesObj = async () => {
    try {
      const data = await wizardAPI.getObjectivesForSelection()
      const raw = Array.isArray(data) ? data : (data?.results ?? data?.data ?? [])
      const list = Array.isArray(raw) ? raw : []
      const safeList = list
        .filter((ele) => ele != null)
        .map((ele) => ({
          ...ele,
          id: ele?.id ?? ele?.pk,
          title: ele?.title ?? ele?.Nom ?? '(Objectif)',
        }))
      setUserMesObj(safeList)
    } catch (error) {
      console.error('Error fetching user objectives:', error)
      setUserMesObj([])
      setLoadError(true)
      alert('Erreur lors du chargement des objectifs. Veuillez réessayer.')
    }
  }

  const getId = (ele) => {
    const id = ele?.id ?? ele?.pk
    if (id == null) return ''
    return String(id)
  }

  return (
    <>
      <Dialog fullWidth maxWidth="lg" open={true} className="no-drag">
        <DialogTitle sx={{ color: '#383838 !important' }}>
          Sélectionnez vos 5 objectifs prioritaires
        </DialogTitle>
        <form onSubmit={handleSubmit(onSubmit)}>
          <DialogContent>
            <Box textAlign={'center'} fontWeight={700}>
              Choisissez les cinq objectifs de vie qui comptent le plus pour vous en ce moment. Ils
              deviendront vos projets prioritaires pour les prochaines années.
            </Box>
            <Box mt={3} mb={5}>
              Sélectionnez jusqu'à cinq objectifs de votre liste pour les transformer en projets
              concrets. Chaque objectif sélectionné sera défini comme un projet avec une échéance de
              trois ans, vous aidant ainsi à suivre et réaliser vos ambitions.
            </Box>
            <Box>Selection remain: {5 - selectedCheckboxes.length}</Box>
            {loadError && (
              <Typography color="error" sx={{ mb: 2 }}>Impossible de charger la liste. Vérifiez votre connexion.</Typography>
            )}
            <FormGroup>
              <Grid container spacing={1}>
                {(userMesObj || []).map((ele) => {
                  const id = getId(ele)
                  if (!id) return null
                  const label = ele?.title ?? ele?.Nom ?? '(Objectif)'
                  return (
                    <Grid item xs={4} key={id}>
                      <FormControlLabel
                        className="ficheck"
                        control={
                          <Checkbox
                            name={`idea-${id}`}
                            onChange={handelOnChange}
                            checked={selectedCheckboxes.includes(id)}
                          />
                        }
                        label={label}
                        disabled={
                          selectedCheckboxes.length >= 5 && !selectedCheckboxes.includes(id)
                        }
                      />
                    </Grid>
                  )
                })}
              </Grid>
            </FormGroup>
          </DialogContent>
          <DialogActions>
            <Button type="submit" variant="contained">
              Sauvergarder les objectifs sélectionnées
            </Button>
            <Button
              variant="contained"
              onClick={() => {
                handleClose()
                if (w_selectionr) {
                  localStorage.removeItem('w-selectionr')
                  navigate('/')
                }
              }}
            >
              Passer
            </Button>
          </DialogActions>
        </form>
      </Dialog>
    </>
  )
}
